<template>
    <div>
        <div class="imgBox">
          <img class="classImg" :src="classImg" alt="">
        </div>
        <div class="content">
            <div class="nav" v-if="classList.length"> 
              <div :class="{'active':active===index}" v-for="(item,index) in classList" :key="item.id" @click="changeActive(index,item)">
                  {{item.name}}
              </div>
            </div>
            <div class="list">
                <van-list 
                    v-model="loading" 	                     		 
                    :finished="finished" 							 
                    finished-text="没有更多数据了"						 
                    @load="onLoad" 									
                    offset="50"									 
                    :error.sync="error" 							 
                    error-text="请求失败，点击重新加载"					 
                    >
                    <div class="content-item"  v-for="item in list" :key="item.id" @click="goDetail(item.id)">
                          <div class="left">
                            <div class="title">{{item.title}}</div>
                            <div class="tip">
                            <span v-if="item.visit">浏览 {{item.visit}}</span><span>{{item.createTime}}</span>
                          </div>
                        </div>
                        <div class="right">
                          <img :src="item.imageInputs" alt="">
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data(){
    return{
      loading: true, 		// 是否处在加载状态
      finished: false, 		// 是否已加载完成
      error: false, 		// 是否加载失败
      list: [],				// 列表
      page:1,
      limit:10,
      total: 0,			// 数据总条数
      active:0,
      classId:0,
      classImg:'',
      classList:[]
    }
  },
  created(){
    this.getClass()
     
  },

   activated () {
        if (!this.$route.meta.isBack) {
            this.init() // 不是患者详情页面(detail.vue)进入，更新初始化列表数据
        } else {
            // 这是详情页返回
            this.$route.meta.isBack = false // 重置详情页标识isBack
        }
    },
    deactivated(){
       
    },
  beforeRouteLeave (to, from, next) {
    console.log(123413)
  if (to.name == "detail"){
      from.meta.keepAlive = true;
  }else{
      from.meta.keepAlive = false;
  }
  next();
},
  methods:{
    init(){
       Object.assign(this.$data, this.$options.data())
       this.getClass()
    },
   
    
    getClass(){
        this.http.get(`/api/front/article/category/gwPidList?pid=${this.$route.query.id}`).then((res)=>{    
            if(res.data.data.list){
                this.classList = res.data.data.list
                this.classId = this.classList[0].id
                this.classImg = this.classList[0].extra

                this.onLoad()
                // this.getList()
            }
        })
    },
    goDetail(id){
      this.$router.push({
          path: '/detail',
          query: {
            id:id
          }
      })
    },
    changeActive(index,item){
      this.page = 1
      this.loading = true; 
      this.finished = false
      this.list= []
      this.active = index
      this.classId = item.id
      this.classImg = item.extra
      this.onLoad()
    },
    // 获取列表数据方法
    async getList() {
      this.http.get(`/api/front/article/list/${this.classId}?page=${this.page}&limit=${this.limit}`).then(res =>{
           if (res.data.data.list === 0) {  		// 判断获取数据条数若等于0
                this.list = [];				// 清空数组
                this.finished = true;		// 停止加载
            }
            // 若数据条数不等于0
            this.total = res.data.data;		// 给数据条数赋值
            this.list.push(...res.data.data.list)	// 将数据放入list中
            this.loading = false;			// 加载状态结束 
            // 如果list长度大于等于总数据条数,数据全部加载完成
            if (this.list.length >= res.data.data.total) {
                this.finished = true;		// 结束加载状态
            }
      })
    },
	// 被 @load调用的方法
    onLoad() { // 若加载条到了底部
      let timer = setTimeout(() => {	// 定时器仅针对本地数据渲染动画效果,项目中axios请求不需要定时器
        this.getList();					// 调用上面方法,请求数据
        this.page++;					// 分页数加一
        this.finished && clearTimeout(timer);//清除计时器
      }, 100);
    },
	// 加载失败调用方法
    onRefresh() {
      this.finished = false; 		// 清空列表数据
      this.loading = true; 			// 将 loading 设置为 true，表示处于加载状态
      this.page = 1;				// 分页数赋值为1
      this.list = [];				// 清空数组
      this.onLoad(); 				// 重新加载数据
    }
  }
}
</script>

<style lang="less" scoped>
.imgBox{
   background-color: #fff;
   width: 100%;
    height: 2.1rem;
    position: fixed;
    left: 0;
    top: 0;
    border: none;

.classImg{
  width: 100%;
  height: 100%;
}
}
.content{
    // min-height: calc(100vh - 0.2rem);
//   height: calc(100vh - 1.5rem);
//   padding-top: 2.8rem;
   .nav{
        position: fixed;
        left: 0.2rem;
        top:1.6rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 6.46rem;
        background: #fff;
        border-radius: 16px 16px 16px 16px;
        height: 0.96rem;
        padding: 0.08rem 0.32rem;
        overflow-x: scroll;

      div{
        background: #F5F5F5;
        color: #666;
        border-radius: 25px 25px 25px 25px;
        opacity: 1;
        padding: .08rem .24rem ;
        margin-right: 0.32rem;
        flex-shrink: 0;
        font-size: 0.24rem;
      }
      .active{
        background: rgba(236,106,61,0.2);
        color: #EC6A3D;
      }
   }
   .list{
    padding-top:2.7rem;
    margin: 0.2rem;
    width: 7.1rem;
    display: flex;
    flex-direction: column;
    // overflow-y: scroll;
    word-break: break-all;
    // height: calc(100vh - 1rem);
    .content-item{
        display: flex;
        justify-content: space-between;
        background: #fff;
        border-radius: 0.16rem;
        margin-bottom: 0.2rem;
        padding: 0.26rem;
        width: 100%;
        box-sizing:border-box;
        height: 2.1rem;
        .left{
          flex: 1;
          overflow:hidden;
          margin-right: 0.5rem;
          .title{
            font-size: 0.28rem;
            color: #000;
            margin-top: 0.1rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
          }
          .tip{
            span{
                display: inline-block;
                background: #F5F5F5;
                border-radius: 0.04rem;
                color: #666666;
                font-size: 0.2rem;
                margin-right: 0.18rem;
                padding: 0.05rem 0.1rem;
            }
          }
        }
        .right{
            width: 2.2rem;
            height: 1.6rem;
            border-radius: 0.08rem;
            background: #000;
            img{
                width: 2.2rem;
                height: 1.6rem;
            }
        }
    }
   }
}
</style>


// WEBPACK FOOTER //
// src/components/list.vue